import { SignatureAction } from "@enums/signatureAction";
import { SignatureModule } from "@enums/signatureModule";
import deleteStorageService from "@services/Shared/storage/deleteStorageService";
import postFilesToSignService from "@services/Shared/storage/postFilesToSignService";
import { getNameFileFromLink } from "@utils/helpers/gcp.helper";

export const deleteFile = async (
  uuid: string,
  fileLink: string,
  module: SignatureModule
) => {
  const fileName = getNameFileFromLink(fileLink);
  if (!fileName) {
    return;
  }

  const { data: signedUrls } = await postFilesToSignService(
    uuid,
    [fileName],
    module,
    SignatureAction.Delete
  );

  const signedUrl = signedUrls[fileName];
  if (!signedUrl) {
    return;
  }

  await deleteStorageService(signedUrl);
};
